
export enum PlanoPeriodo {
    MENSAL = "Mensal",
    SEMESTRAL = "Semestral",
    ANUAL = "Anual",
}